import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import { useSelector } from 'react-redux'

import css from './PageCount.module.scss'

const PageCount: React.FC = () => {
  const pageCount = useSelector(migrationProjectSelector.getPageCount)

  return (
    <div className={css.container}>
      {pageCount} page{pageCount > 1 ? 's' : ''}
    </div>
  )
}

export default PageCount
